<script>
  export default {
    mounted() {
    },
  }
</script>

<template>
  <router-view :key="$route.path"></router-view>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/importacao/componentes/Importacao.vue